// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__HuyZJ","aboutImage":"About_aboutImage__lp9I5","aboutHeading":"About_aboutHeading__GMWlI","aboutText":"About_aboutText__epbwg"};